import { IconButton } from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { useField } from "react-final-form";

interface IBackButton {
  classes: any;
  handleCloseRoutePanel: any;
}

const BackButton = ({ classes, handleCloseRoutePanel }: IBackButton) => {
  const routeIdField = useField("route.id");
  const routeNameField = useField("route.name");
  const routeBusBayNumberField = useField("route.busBayNumber");
  const routeStartTimeField = useField("route.startTime");
  const routeEndTimeField = useField("route.endTime");
  const routeDriverIdField = useField("route.driverId");
  const routeBusAssistantIdField = useField("route.busAssistantId");
  const routeVehicleIdField = useField("route.vehicleId");
  const routeBackupDriversField = useField("route.backupDriverIds");
  const routeBackupVehiclesField = useField("route.backupVehicleIds");
  const routeBackupBusAssistantsField = useField("route.backupBusAssistantIds");
  const routeLocationsField = useField("route.routeLocations");

  //for subcontractor payment
  const routeAssignedSubcontractorField = useField(
    "route.assignedSubcontractor"
  );

  const handleClose = async () => {
    routeIdField.input.onChange("");
    routeNameField.input.onChange("");
    routeBusBayNumberField.input.onChange("");
    routeStartTimeField.input.onChange("");
    routeEndTimeField.input.onChange("");
    routeDriverIdField.input.onChange("");
    routeBusAssistantIdField.input.onChange("");
    routeVehicleIdField.input.onChange("");
    routeBackupDriversField.input.onChange("");
    routeBackupVehiclesField.input.onChange("");
    routeBackupBusAssistantsField.input.onChange("");
    routeLocationsField.input.onChange("");
    routeAssignedSubcontractorField.input.onChange("");
  };

  return (
    <IconButton
      aria-label="Back"
      size="medium"
      className={classes}
      onClick={() => handleClose().then(() => handleCloseRoutePanel())}
    >
      <KeyboardBackspaceIcon fontSize="inherit" />
    </IconButton>
  );
};

export default BackButton;
